import { createSlice } from '@reduxjs/toolkit'
import { saveState } from '../../localStorage'

const initialState = {
    value: {
        electricalPanelFlag: false,
        status: null,
        errorMessage: null,
        roi:{
            monthlyResidentBenefit: null,
            netROI10Year: null,
            yearsToBreakEven: null,
            incentivesApplied: [],
            messages: [],
            rateArray: [],
            markupArray: [],
            roiChartArray: []
        },
        cost:{
            monthlyNetworking: null,
            monthlyLoadManagement: null,
            totalAnnualCost: null,
            oneTimeHardware: null,
            oneTimeInstallationLabor: null,
            oneTimeProjectManagement: null,
            oneTimeTotal: null,
            dataSource: null
        },
        incentives: {}
    },
    recurringCosts: [],
    oneTimeCosts: [],
    appliedIncentives: [],
    utilitiesList: []
}

const initUtilitiesList = (state) => {
    var utilities = state.incentives.filter(incentive => incentive.Type === "Utility").map((incentive) => (incentive.Utility));
    utilities = [...new Set(utilities)];
    utilities.unshift("All");
    return utilities;
}

const formatRoiChartArray = (chart) => {
    if (chart.length === 0) {
        return null;
    }
    let roiChartArray = [];
    for (let i = 0; i < chart.length; i++) {
        // if (chart[i][1] === 0) {
        //     continue;
        // }
        const item = chart[i];
        roiChartArray.push(
            {
                year: Number(item[0]),
                formattedRoi: `$${item[1]}`,
                'Net ROI': item[1]
            }
        );
    }
    return roiChartArray;
}

export const outputs = createSlice({
  name: 'outputs',
  initialState: initialState,
  reducers: {
    populateOutputs: (state, action) => {
      state.value = action.payload
      state.utilitiesList = initUtilitiesList(action.payload);
      state.value.roi.roiChartArray = action.payload.roi.roiChartArray.map((arr) =>formatRoiChartArray(arr));
      saveState('outputs', state);
    },
    updateRecurringCosts(state, action) {
        let total = 0;
        for (let i = 0; i < action.payload.length - 1; i++) {
            if (!action.payload[i].isTotal) {
                total += Number(action.payload[i].number);
            }
        }
        const newTotal = {
            isTotal: true,
            number: total*12,
            label: "Total Annual Costs"
        }
        state.recurringCosts = [...action.payload.slice(0, -1), newTotal];
        saveState('outputs', state);

    },
    updateOneTimeCosts(state, action) {
        let total = 0;
        for (let i = 0; i < action.payload.length - 1; i++) {
            if (!action.payload[i].isTotal) {
                total += Number(action.payload[i].number);
            }
        }
        const newTotal = {
            isTotal: true,
            number: total,
            label: "Total One-Time Costs"
        }
        state.oneTimeCosts = [...action.payload.slice(0, -1), newTotal];
        saveState('outputs', state);

    },
    updateElectricalPanelFlag(state, action) {
        state.value.electricalPanelFlag = action.payload;
        saveState('outputs', state);
    }
}
})

// Action creators are generated for each case reducer function
export const { populateOutputs, updateRecurringCosts, updateOneTimeCosts, updateElectricalPanelFlag } = outputs.actions

export default outputs.reducer